import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class DeleteModal extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.state = {show: false}
  }

  componentDidMount() {
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleHide() {
    this.setState({ show: false });
  }

  render() {
    return (
      <div>
        <Button bsStyle="primary" className='delete-entry action-btn' onClick={this.handleShow}>
        </Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
               {this.props.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {this.props.text}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.props.delete}>Verwijderen</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteModal.js